// Step definitions for each tunnel
// Types: 'select' (single), 'multi' (multi-select), 'text', 'number', 'slider', 'textarea', 'file'

export const INTENTION_OPTIONS = [
  { value: "vendre", label: "Je veux vendre ma conciergerie", desc: "Cession totale ou partielle de mon activité", icon: "sale" },
  { value: "passif", label: "Je veux sortir de l'opérationnel mais garder un revenu", desc: "Revenu passif sans gestion quotidienne", icon: "passive" },
  { value: "deleguer", label: "Je veux déléguer une grosse partie et récupérer du temps", desc: "Garder l'activité mais me libérer", icon: "delegate" },
  { value: "incertain", label: "Je ne sais pas encore", desc: "J'ai besoin d'y voir plus clair", icon: "question" }
];

export const COMMON_STEPS = [
  {
    id: "info-perso",
    title: "Vos coordonnées",
    subtitle: "Ces informations restent strictement confidentielles.",
    fields: [
      { id: "prenom", type: "text", label: "Prénom", placeholder: "Votre prénom", required: true, half: true },
      { id: "nom", type: "text", label: "Nom", placeholder: "Votre nom", required: true, half: true },
      { id: "email", type: "email", label: "Email", placeholder: "votre@email.com", required: true, half: true },
      { id: "telephone", type: "tel", label: "Téléphone", placeholder: "06 XX XX XX XX", required: true, half: true },
      { id: "societe", type: "text", label: "Nom de la société", placeholder: "Nom de votre structure", required: false },
      { id: "ville", type: "text", label: "Ville / Zone d'activité", placeholder: "Ex: Lyon, Côte d'Azur...", required: true }
    ]
  },
  {
    id: "info-business",
    title: "Votre activité",
    subtitle: "Aidez-nous à comprendre votre conciergerie.",
    fields: [
      { id: "logements", type: "number", label: "Nombre de logements gérés", placeholder: "Ex: 15", required: true, half: true },
      { id: "anciennete", type: "number", label: "Ancienneté (en années)", placeholder: "Ex: 3", required: true, half: true },
      { id: "ca_annuel", type: "number", label: "CA annuel approximatif (€)", placeholder: "Ex: 150000", required: true, half: true },
      { id: "heures_semaine", type: "number", label: "Heures travaillées / semaine", placeholder: "Ex: 45", required: true, half: true }
    ]
  },
  {
    id: "info-profil",
    title: "Votre profil",
    subtitle: "Évaluez votre situation personnelle.",
    fields: [
      { id: "fatigue", type: "slider", label: "Niveau de fatigue", min: 1, max: 10, required: true },
      { id: "role", type: "select-cards", label: "Votre rôle actuel dans l'activité", required: true, options: [
        { value: "tout_seul", label: "Je fais presque tout seul" },
        { value: "supervise", label: "Je supervise mais je suis très impliqué" },
        { value: "equipe_indispensable", label: "J'ai une équipe mais je reste indispensable" },
        { value: "pilotage", label: "Je suis surtout en pilotage" }
      ]}
    ]
  }
];

// TUNNEL RACHAT
export const RACHAT_STEPS = [
  {
    id: "rachat-1",
    title: "Votre projet de cession",
    subtitle: "Quelques questions pour comprendre votre situation.",
    fields: [
      { id: "raison_vente", type: "select-cards", label: "Raison principale de votre volonté de vendre", required: true, options: [
        { value: "changement", label: "Changement d'activité" },
        { value: "fatigue", label: "Fatigue / épuisement" },
        { value: "rentabilite", label: "Manque de rentabilité" },
        { value: "autre", label: "Autre" }
      ]},
      { id: "delai_cession", type: "select-cards", label: "Délai envisagé pour la cession", required: true, options: [
        { value: "immediat", label: "Immédiat" },
        { value: "1_3_mois", label: "1 à 3 mois" },
        { value: "3_6_mois", label: "3 à 6 mois" },
        { value: "plus_tard", label: "Plus tard" }
      ]},
      { id: "prix_souhaite", type: "text", label: "Prix idéal souhaité", placeholder: "Ex: 150 000 € ou 'je ne sais pas'", required: false }
    ]
  },
  {
    id: "rachat-2",
    title: "Votre portefeuille",
    subtitle: "Détails sur votre parc et votre activité.",
    fields: [
      { id: "nb_proprietaires", type: "number", label: "Nombre de propriétaires actifs", placeholder: "Ex: 12", required: true },
      { id: "repartition_activite", type: "multi", label: "Répartition de l'activité", required: false, options: [
        { value: "conciergerie_classique", label: "Conciergerie classique" },
        { value: "sous_location", label: "Sous-location" },
        { value: "lcd_gestion", label: "Location courte durée en gestion" },
        { value: "autres_services", label: "Autres services" }
      ]},
      { id: "rentable", type: "select-cards", label: "Votre activité est-elle rentable aujourd'hui ?", required: true, options: [
        { value: "oui_clairement", label: "Oui clairement" },
        { value: "oui_faiblement", label: "Oui mais faiblement" },
        { value: "difficile_a_dire", label: "Difficile à dire" },
        { value: "non", label: "Non" }
      ]},
      { id: "benefice_mensuel", type: "number", label: "Bénéfice mensuel approximatif / EBE (€)", placeholder: "Ex: 3000", required: false }
    ]
  },
  {
    id: "rachat-3",
    title: "Structure et transférabilité",
    subtitle: "Ces éléments sont essentiels pour évaluer une reprise.",
    fields: [
      { id: "contrats_formalises", type: "select-cards", label: "Contrats propriétaires formalisés ?", required: true, options: [
        { value: "tous", label: "Tous" },
        { value: "majorite", label: "La majorité" },
        { value: "peu", label: "Peu" },
        { value: "non", label: "Non" }
      ]},
      { id: "transferable", type: "select-cards", label: "Logements / clients transférables dans le cadre d'une reprise ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "partiellement", label: "Partiellement" },
        { value: "non", label: "Non" },
        { value: "ne_sais_pas", label: "Je ne sais pas" }
      ]},
      { id: "equipe", type: "select-cards", label: "Avez-vous une équipe ?", required: true, options: [
        { value: "non", label: "Non" },
        { value: "freelance", label: "Freelances" },
        { value: "salaries", label: "Salariés" },
        { value: "mixte", label: "Mixte" }
      ]},
      { id: "nb_equipe", type: "number", label: "Si oui, combien de personnes ?", placeholder: "Ex: 3", required: false }
    ]
  },
  {
    id: "rachat-4",
    title: "Outils et process",
    subtitle: "Le niveau de structuration impacte directement la valorisation.",
    fields: [
      { id: "outils", type: "multi", label: "Outils utilisés actuellement", required: false, options: [
        { value: "pms", label: "PMS / Channel manager" },
        { value: "messagerie", label: "Outil de messagerie" },
        { value: "revenue_mgmt", label: "Revenue management" },
        { value: "crm", label: "CRM" },
        { value: "aucun", label: "Aucun système structuré" }
      ]},
      { id: "process_documentes", type: "select-cards", label: "Vos process sont-ils documentés ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "partiellement", label: "Partiellement" },
        { value: "non", label: "Non" }
      ]},
      { id: "absence_7j", type: "select-cards", label: "Si vous vous arrêtez 7 jours, que se passe-t-il ?", required: true, options: [
        { value: "rien", label: "Rien" },
        { value: "perturbations", label: "Quelques perturbations" },
        { value: "ralentissement", label: "Gros ralentissement" },
        { value: "depend_de_moi", label: "Tout dépend de moi" }
      ]},
      { id: "tendance_12mois", type: "select-cards", label: "Sur les 12 derniers mois, votre activité a...", required: true, options: [
        { value: "grossi", label: "Grossi" },
        { value: "stagne", label: "Stagné" },
        { value: "recule", label: "Reculé" }
      ]}
    ]
  },
  {
    id: "rachat-5",
    title: "Éléments de cession",
    subtitle: "Derniers détails pour finaliser votre dossier.",
    fields: [
      { id: "elements_cession", type: "multi", label: "Que souhaitez-vous inclure dans une éventuelle cession ?", required: false, options: [
        { value: "portefeuille", label: "Portefeuille clients" },
        { value: "contrats", label: "Contrats" },
        { value: "equipe", label: "Équipe" },
        { value: "marque", label: "Marque" },
        { value: "site_web", label: "Site web" },
        { value: "outils_process", label: "Outils / Process" },
        { value: "autre", label: "Autre" }
      ]},
      { id: "documents_upload", type: "file", label: "Déposer des documents (optionnel)", required: false, accept: ".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg", multiple: true },
      { id: "commentaire_libre", type: "textarea", label: "Autre chose à nous dire ?", placeholder: "Informations complémentaires...", required: false }
    ]
  }
];

// TUNNEL PASSIF
export const PASSIF_STEPS = [
  {
    id: "passif-1",
    title: "Votre situation",
    subtitle: "Aidez-nous à comprendre ce qui vous pousse à sortir de l'opérationnel.",
    fields: [
      { id: "situation_passif", type: "select-cards", label: "Qu'est-ce qui décrit le mieux votre situation ?", required: true, options: [
        { value: "epuise", label: "Je suis épuisé" },
        { value: "reconversion", label: "Je veux me reconvertir" },
        { value: "plus_envie", label: "Je n'ai plus envie de gérer le quotidien" },
        { value: "recuperer_temps", label: "Je veux récupérer du temps sans tout arrêter" }
      ]},
      { id: "continuer_revenu", type: "select-cards", label: "Voulez-vous continuer à percevoir un revenu lié à votre parc ?", required: true, options: [
        { value: "oui_absolument", label: "Oui absolument" },
        { value: "oui_si_clair", label: "Oui si le modèle est clair" },
        { value: "ouvert", label: "Je suis ouvert" },
        { value: "ne_sais_pas", label: "Je ne sais pas" }
      ]},
      { id: "pret_sortir_operationnel", type: "select-cards", label: "Prêt à ne plus gérer l'opérationnel au quotidien ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "partiellement", label: "Partiellement" },
        { value: "non", label: "Non" }
      ]}
    ]
  },
  {
    id: "passif-2",
    title: "Vos attentes",
    subtitle: "Pour vous proposer la meilleure solution.",
    fields: [
      { id: "implication_souhaitee", type: "select-cards", label: "Quel niveau d'implication souhaitez-vous garder ?", required: true, options: [
        { value: "aucun", label: "Aucun" },
        { value: "supervision_legere", label: "Supervision légère" },
        { value: "relation_proprio", label: "Relation propriétaire uniquement" },
        { value: "autre", label: "Autre" }
      ]},
      { id: "contrats_transferables_passif", type: "select-cards", label: "Contrats actuels transférables ou modifiables ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "partiellement", label: "Partiellement" },
        { value: "non", label: "Non" },
        { value: "ne_sais_pas", label: "Je ne sais pas" }
      ]},
      { id: "douleur_principale", type: "select-cards", label: "Votre plus grosse douleur actuelle", required: true, options: [
        { value: "charge_mentale", label: "Charge mentale" },
        { value: "imprevus", label: "Imprévus" },
        { value: "voyageurs", label: "Voyageurs" },
        { value: "proprietaires", label: "Propriétaires" },
        { value: "equipe", label: "Équipe" },
        { value: "rentabilite", label: "Rentabilité" },
        { value: "temps", label: "Manque de temps" }
      ]}
    ]
  },
  {
    id: "passif-3",
    title: "Objectif et délai",
    subtitle: "Pour calibrer notre proposition.",
    fields: [
      { id: "objectif_principal_passif", type: "select-cards", label: "Si une structure reprenait l'opérationnel, quel serait votre objectif ?", required: true, options: [
        { value: "liberte", label: "Liberté" },
        { value: "stabilite", label: "Stabilité" },
        { value: "revenu", label: "Revenu" },
        { value: "changement_vie", label: "Changement de vie" },
        { value: "autre_projet", label: "Me concentrer sur autre chose" }
      ]},
      { id: "delai_sortie", type: "select-cards", label: "Dans quel délai voulez-vous sortir du quotidien ?", required: true, options: [
        { value: "immediatement", label: "Immédiatement" },
        { value: "1_3_mois", label: "1 à 3 mois" },
        { value: "3_6_mois", label: "3 à 6 mois" },
        { value: "plus_tard", label: "Plus tard" }
      ]},
      { id: "logements_exclure", type: "select-cards", label: "Des logements à conserver ou exclure ?", required: false, options: [
        { value: "oui", label: "Oui" },
        { value: "non", label: "Non" }
      ]},
      { id: "logements_exclure_detail", type: "textarea", label: "Si oui, précisez", placeholder: "Détails...", required: false, showIf: { field: "logements_exclure", value: "oui" } }
    ]
  }
];

// TUNNEL DELEGATION (internal routing to Goodtime)
export const DELEGATION_STEPS = [
  {
    id: "delegation-1",
    title: "Ce que vous souhaitez déléguer",
    subtitle: "Identifions vos priorités.",
    fields: [
      { id: "deleguer_priorite", type: "multi", label: "Que souhaitez-vous déléguer en priorité ?", required: true, options: [
        { value: "messagerie", label: "Messagerie voyageurs" },
        { value: "annonces", label: "Gestion annonces / plateformes" },
        { value: "litiges", label: "Litiges / administratif" },
        { value: "pricing", label: "Pricing / diffusion" },
        { value: "support", label: "Support global" }
      ]},
      { id: "temps_recuperer", type: "select-cards", label: "Combien de temps voulez-vous récupérer ?", required: true, options: [
        { value: "un_peu", label: "Un peu" },
        { value: "30_pct", label: "Environ 30%" },
        { value: "50_pct", label: "Environ 50%" },
        { value: "70_plus", label: "70% ou plus" }
      ]},
      { id: "garder_quoi", type: "multi", label: "Souhaitez-vous garder...", required: true, options: [
        { value: "relation_proprio", label: "La relation propriétaire" },
        { value: "vision_strat", label: "La vision stratégique" },
        { value: "dev_commercial", label: "Le développement commercial" },
        { value: "supervision_legere", label: "Seulement une supervision légère" }
      ]}
    ]
  },
  {
    id: "delegation-2",
    title: "Votre situation actuelle",
    subtitle: "Pour évaluer le meilleur accompagnement.",
    fields: [
      { id: "croissance", type: "select-cards", label: "Votre activité est encore en croissance ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "stable", label: "Stable" },
        { value: "difficulte", label: "En difficulté" }
      ]},
      { id: "blocage", type: "multi", label: "Qu'est-ce qui vous bloque aujourd'hui ?", required: true, options: [
        { value: "temps", label: "Manque de temps" },
        { value: "charge_mentale", label: "Surcharge mentale" },
        { value: "equipe", label: "Manque d'équipe" },
        { value: "structure", label: "Manque de structure" },
        { value: "outils", label: "Outils dispersés" },
        { value: "scaling", label: "Difficulté à scaler" }
      ]},
      { id: "utilise_pms", type: "select-cards", label: "Utilisez-vous déjà un PMS / channel manager / automatisations ?", required: true, options: [
        { value: "oui_structures", label: "Oui, bien structurés" },
        { value: "partiellement", label: "Partiellement" },
        { value: "non", label: "Non" }
      ]}
    ]
  },
  {
    id: "delegation-3",
    title: "Vos attentes",
    subtitle: "Pour calibrer notre proposition.",
    fields: [
      { id: "pret_methode", type: "select-cards", label: "Prêt à mettre en place une méthode plus structurée ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "peut_etre", label: "Peut-être" },
        { value: "non", label: "Non" }
      ]},
      { id: "type_accompagnement", type: "select-cards", label: "Que cherchez-vous ?", required: true, options: [
        { value: "delegation_operationnelle", label: "Une délégation opérationnelle" },
        { value: "accompagnement", label: "Un accompagnement structuré" },
        { value: "systeme_complet", label: "Un système complet type operating system" },
        { value: "ne_sais_pas", label: "Je ne sais pas encore" }
      ]},
      { id: "delai_delegation", type: "select-cards", label: "Dans quel délai voulez-vous mettre ça en place ?", required: true, options: [
        { value: "immediatement", label: "Immédiatement" },
        { value: "1_3_mois", label: "1 à 3 mois" },
        { value: "plus_tard", label: "Plus tard" }
      ]}
    ]
  }
];

// TUNNEL INCERTAIN
export const INCERTAIN_STEPS = [
  {
    id: "incertain-1",
    title: "Clarifions votre situation",
    subtitle: "4 questions pour vous orienter vers la bonne solution.",
    fields: [
      { id: "moteur_principal", type: "select-cards", label: "Qu'est-ce qui vous pousse le plus aujourd'hui ?", required: true, options: [
        { value: "vendre", label: "Vendre" },
        { value: "souffler", label: "Souffler" },
        { value: "garder_deleguer", label: "Garder l'activité mais déléguer" },
        { value: "perdu", label: "Je suis perdu" }
      ]},
      { id: "implique_6mois", type: "select-cards", label: "Voulez-vous encore être impliqué dans l'activité dans 6 mois ?", required: true, options: [
        { value: "oui", label: "Oui" },
        { value: "un_peu", label: "Un peu" },
        { value: "non", label: "Non" }
      ]},
      { id: "priorite_principale", type: "select-cards", label: "Votre priorité n°1 ?", required: true, options: [
        { value: "cash", label: "Obtenir du cash" },
        { value: "revenu", label: "Garder un revenu" },
        { value: "temps", label: "Récupérer du temps" },
        { value: "clarte", label: "Clarifier ma situation" }
      ]},
      { id: "niveau_fatigue_incertain", type: "select-cards", label: "Votre niveau de fatigue ?", required: true, options: [
        { value: "faible", label: "Faible" },
        { value: "moyen", label: "Moyen" },
        { value: "eleve", label: "Élevé" },
        { value: "extreme", label: "Extrême" }
      ]}
    ]
  }
];

// Auto-routing logic for uncertain tunnel
export function routeIncertain(data) {
  const { moteur_principal, implique_6mois, priorite_principale, niveau_fatigue_incertain } = data;
  let scores = { vendre: 0, passif: 0, deleguer: 0 };

  // Moteur principal
  if (moteur_principal === "vendre") scores.vendre += 3;
  if (moteur_principal === "souffler") scores.passif += 2;
  if (moteur_principal === "garder_deleguer") scores.deleguer += 3;
  if (moteur_principal === "perdu") scores.passif += 1;

  // Implication 6 mois
  if (implique_6mois === "non") { scores.vendre += 2; scores.passif += 1; }
  if (implique_6mois === "un_peu") { scores.passif += 2; scores.deleguer += 1; }
  if (implique_6mois === "oui") scores.deleguer += 2;

  // Priorité
  if (priorite_principale === "cash") scores.vendre += 3;
  if (priorite_principale === "revenu") scores.passif += 3;
  if (priorite_principale === "temps") scores.deleguer += 2;
  if (priorite_principale === "clarte") { scores.passif += 1; scores.deleguer += 1; }

  // Fatigue
  if (niveau_fatigue_incertain === "extreme") { scores.passif += 2; scores.vendre += 1; }
  if (niveau_fatigue_incertain === "eleve") scores.passif += 1;
  if (niveau_fatigue_incertain === "moyen") scores.deleguer += 1;

  const max = Math.max(scores.vendre, scores.passif, scores.deleguer);
  if (scores.vendre === max) return "vendre";
  if (scores.passif === max) return "passif";
  return "deleguer";
}

// Result screen messages
export const RESULT_MESSAGES = {
  vendre: {
    title: "Dossier reçu.",
    subtitle: "Votre demande va être étudiée de manière confidentielle par notre équipe.",
    body: "Si votre profil entre dans notre cadre de reprise, nous reviendrons vers vous rapidement avec une première analyse.",
    cta: "Votre dossier est entre de bonnes mains."
  },
  passif: {
    title: "Demande enregistrée.",
    subtitle: "Nous allons analyser si une bascule de votre activité vers un modèle plus passif est réaliste dans votre situation.",
    body: "Un expert va étudier votre portefeuille et vous proposer un scénario chiffré sous 48h.",
    cta: "Vous êtes sur la bonne voie."
  },
  deleguer: {
    title: "Profil enregistré.",
    subtitle: "Nous allons vérifier si votre profil est compatible avec une délégation structurée.",
    body: "Un spécialiste opérationnel va analyser votre situation et vous proposer un accompagnement adapté.",
    cta: "On revient vers vous très vite."
  }
};
